import { MonthlyPaymentsSimulatorSection } from '@/components/MonthlyPaymentsSimulator/MonthlyPaymentsSimulatorSection';
import {
    SeoTextWithNavigationEntry
  } from '@/components/Seo/SeoTextWithNavigation';
  import { SimulatorLayout } from '@/components/simulators/SimulatorLayout';
  import { NextSeo } from 'next-seo';
  import Head from 'next/head';
  import { useRouter } from 'next/router';
  import { useIntl } from 'react-intl';
  
  const MonthlyPaymentsSimulator = () => {
    const { formatMessage } = useIntl();
    const router = useRouter();
  
    const seoEntries: SeoTextWithNavigationEntry[] = [...new Array(17)].map((_, i) => (
      {
        id: `block-${i + 1}`,
        title: formatMessage({ id: `monthly_payments_simulator.content.block${i + 1}.title` }),
        text: formatMessage({ id: `monthly_payments_simulator.content.block${i + 1}.text` }),
      }
    ));
  
    return (
      <SimulatorLayout title={formatMessage({ id: 'monthly_payments_simulator.title' })} subtitle={formatMessage({ id: 'monthly_payments_simulator.subtitle' })} seoEntries={seoEntries}>
        <NextSeo
          title={formatMessage({ id: 'monthly_payments_simulator.meta.title' })}
          description={formatMessage({ id: 'monthly_payments_simulator.meta.description' })}
          canonical={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}/${router.locale}/tools/monthly-payments-calculator`}
          openGraph={{
            type: 'website',
            url: `${process.env.NEXT_PUBLIC_PUBLIC_PATH}/${router.asPath}/`,
            title: formatMessage({ id: 'monthly_payments_simulator.meta.title' }),
            description: formatMessage({ id: 'monthly_payments_simulator.meta.description' }),
            images: [
              {
                url: `${process.env.NEXT_PUBLIC_PUBLIC_PATH}/img/monthly-payments-calculator/og_${router.locale}.png`,
                alt: formatMessage({ id: 'homepage.meta.preview' }),
              },
            ],
          }}
        />
        <Head>
          <meta
            name="twitter:title"
            content={formatMessage({ id: 'monthly_payments_simulator.meta.title' })}
            />
          <meta
            name="twitter:description"
            content={formatMessage({ id: 'monthly_payments_simulator.meta.description' })}
            />
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:image"
            content={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}/img/monthly-payments-calculator/og_${router.locale}.png`}
            />
        </Head>
        <MonthlyPaymentsSimulatorSection />
      </SimulatorLayout>
    );
  };
  
  export default MonthlyPaymentsSimulator;
  